import { z } from 'zod';

const optionalNonEmptySearchParam = z.preprocess((value) => {
    if (typeof value !== 'string') {
        return undefined;
    }

    const trimmed = value.trim();
    return trimmed ? trimmed : undefined;
}, z.string().optional());

export const passwordResetSearchSchema = z.object({
    resetSecret: optionalNonEmptySearchParam,
    email: optionalNonEmptySearchParam,
});

export type PasswordResetSearch = z.infer<typeof passwordResetSearchSchema>;
